define('home/views/ProfileFollowingView',[
    'underscore',

    'home/views/common/TabbedView',
    'home/views/UserCollectionView',
    'home/views/ForumCardCollectionView',
    'home/views/common/FetchableCollectionFooterView',
    'home/views/ProfileFollowingPeopleEmptyView',
    'home/views/ProfileFollowingCommunitiesEmptyView',

    'home/templates/profileFollowing',
], function (
    _,

    TabbedView,
    UserCollectionView,
    ForumCardCollectionView,
    FetchableCollectionFooterView,
    ProfileFollowingPeopleEmptyView,
    ProfileFollowingCommunitiesEmptyView,

    profileFollowingTemplate
) {
    'use strict';

    /**
     * The view that appears in a user profile following tab. Handles switching between
     * the following feeds for users and forums.
     */
    var ProfileFollowingView = TabbedView.extend({
        defaultTab: 'people',

        template: profileFollowingTemplate,
        templateHelpers: function () {
            return {
                numCommunitiesFollowing: this.model.getNumCommunitiesFollowing(),
            };
        },

        regions: _.defaults({
            footerRegion: '[data-role=footer-area]',
        }, TabbedView.prototype.regions),

        modelEvents: {
            'change:numFollowing': 'updateNumFollowing',
            'change:numForumsFollowing': 'updateNumForumsFollowing',
            'change:numChannelsFollowing': 'updateNumForumsFollowing',
        },

        initialize: function (options) {
            TabbedView.prototype.initialize.apply(this, arguments);

            this.userProfile = options.userProfile;
        },

        getDefaultOptions: function (activeTab) {
            var feed = activeTab === 'sites' ?
                this.userProfile.forumsFollowing :
                this.userProfile.following;
            return {
                user: this.model,
                model: feed,
                collection: feed.items,
                emptyView: activeTab === 'people' ?
                    ProfileFollowingPeopleEmptyView : ProfileFollowingCommunitiesEmptyView,
                infiniteScroll: true,
            };
        },

        updateTabContent: function (newView) {
            TabbedView.prototype.updateTabContent.call(this, newView);

            this.footerRegion.show(new FetchableCollectionFooterView(this.getDefaultOptions(this.activeTab)));
        },

        updateNumFollowing: function () {
            this.$('[data-role=num-following]').text(this.model.get('numFollowing'));
        },

        updateNumForumsFollowing: function () {
            this.$('[data-role=num-forums-following]').text(this.model.getNumCommunitiesFollowing());
        },

        getTrackingSection: function (activeTab) {
            return activeTab === 'sites' ?
                'following-communities' :
                'following-default';
        },

        getTabView: function (activeTab) {
            var defaultOptions = this.getDefaultOptions(activeTab);
            var view;

            switch (activeTab) {
            case 'people':
                view = new UserCollectionView(defaultOptions);
                break;

            case 'sites':
                view = new ForumCardCollectionView(defaultOptions);
                break;
            default:
                return;
            }

            view.model.ensureFetched();
            return view;
        },
    });

    return ProfileFollowingView;
});

